import React from "react";
import "antd/dist/reset.css";
import'./assets/scss/App.scss';
import 'react-image-crop/src/ReactCrop.scss'

//imoprt Route
import RoutesComponents from "./Routes/index";
import { ThemeProvider as CustomThemeProvider } from "./Common/ThemeContext";
import GlobalLoader from "./Common/GlobalLoader/GlobalLoader";


const App = () => {
  return (
    <CustomThemeProvider>
      <RoutesComponents />
      <GlobalLoader />
    </CustomThemeProvider>
  )
}

export default App;
